import { render, staticRenderFns } from "./GaugeChartPlotly.vue?vue&type=template&id=4310a3bd&scoped=true&"
import script from "./GaugeChartPlotly.vue?vue&type=script&lang=js&"
export * from "./GaugeChartPlotly.vue?vue&type=script&lang=js&"
import style0 from "./GaugeChartPlotly.vue?vue&type=style&index=0&id=4310a3bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310a3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4310a3bd')) {
      api.createRecord('4310a3bd', component.options)
    } else {
      api.reload('4310a3bd', component.options)
    }
    module.hot.accept("./GaugeChartPlotly.vue?vue&type=template&id=4310a3bd&scoped=true&", function () {
      api.rerender('4310a3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/charts/GaugeChartPlotly.vue"
export default component.exports